<template>
  <vs-tabs :position="isSmallerScreen ? 'top' : 'left'" class="tabs-shadow-none" id="profile-tabs" :key="isSmallerScreen">

    <!-- GENERAL -->
    <vs-tab icon-pack="feather" icon="icon-link-2" :label="!isSmallerScreen ? '(a) Orders History' : ''">
      <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
        <orders-history />
      </div>
    </vs-tab>
    <vs-tab icon-pack="feather" icon="icon-lock" :label="!isSmallerScreen ? '(b) Products History' : ''">
      <div class="tab-info md:ml-4 md:mt-0 mt-4 ml-0">
        <products-history />
      </div>
    </vs-tab>
    <vs-tab icon-pack="feather" icon="icon-lock" :label="!isSmallerScreen ? '(c) Customers History' : ''">
      <div class="tab-info md:ml-4 md:mt-0 mt-4 ml-0">
        <customers-history />
      </div>
    </vs-tab>    
  </vs-tabs>
</template>

<script>
import OrdersHistory from './OrdersHistory.vue'
import ProductsHistory from './ProductsHistory.vue'
import CustomersHistory from './CustomersHistory.vue'


export default {
  components: {    
    OrdersHistory,
    ProductsHistory,
    CustomersHistory,    
  },
  data () {
    return { 

    }
  },
  computed: {
    isSmallerScreen () {
      return this.$store.state.windowWidth < 768
    }
  }
}
</script>

<style lang="scss">
#profile-tabs {
  .vs-tabs--content {
    padding: 0;
  }
}
</style>
